const dateFormat = 'MM/DD/YYYY'
const dateTimeFormat = 'MM/DD/YYYY HH:mm:ss'

export {
  dateFormat,
  dateTimeFormat
}
